<template>
  <div class="footer">
    <section class="footer-social-and-links">
      <div class="footer-links">
        <ul class="footer-links__container footer-links__container--group1">
          <li class="footer-links__item footer-links__item--group1">
            <a class="link" href="">
              <span>隐私条款</span>
            </a>
          </li>
          <li class="footer-links__item footer-links__item--group1">
            <a class="link" href="">
              <span>用户协议</span>
            </a>
          </li>
          <li class="footer-links__item footer-links__item--group1">
            <a class="link" href="">
              <span>联系电话</span>
            </a>
          </li>
          <li class="footer-links__item footer-links__item--group1">
            <a class="link" href="">
              <span>意见反馈</span>
            </a>
          </li>
          <li class="footer-links__item footer-links__item--group1">
            <a class="link" href="">
              <span>更新日志</span>
            </a>
          </li>
        </ul>
        <ul class="footer-links__container footer-links__container--group2">
          <li class="footer-links__item">
            <a class="link" href="">
              <span>版权所有</span>
            </a>
          </li>
          <li class="footer-links__item">
            <a class="link" href="">
              <span>鲁ICP备09046804号-2</span>
            </a>
          </li>
          <li class="footer-links__item">
            <a class="link" href="">
              <span>鲁公网安备 11010232671623号 </span>
            </a>
          </li>
        </ul>
      </div>
      <div class="footer-social">
        <ul
          class="footer-social__container footer-social__qr-container flex-end"
        >
         
        </ul>
      </div>
    </section>

    <div class="floating-button">
      <ul class="floating-button__group">
        <li
          class="floating-button__content"
          v-on:mouseover="addActive($event)"
          v-on:mouseleave="removeActive($event)"
        >
          <a class="floating-button__link" href="">
            <span class="floating-button__img">
              <img
                src="https://www.mercedes-benz.com.cn/etc/designs/mb-cn/images/Ic_Livechat_new.png"
                alt=""
              />
            </span>
            <span class="floating-button__title">在线客服</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    addActive($event) {
      $event.currentTarget.className =
        "floating-button__content floating-button__content-action";
    },
    removeActive($event) {
      $event.currentTarget.className = "floating-button__content";
    },
  },
};
</script>

<style>
.footer {
  z-index: 600;
  width: 100%;
  position: relative;
  background: #000;
}
.footer-social-and-links {
  width: 86%;
  font-size: 12px;
  background: #000;
  min-height: 106px;
  padding: 10px 7%;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.footer-links {
  color: #bfbfbf;
  -ms-flex: 1;
  flex: 1;
}
.footer-links__container {
  display: flex;
}
.footer-links__container--group1 {
  padding-bottom: 12px;
}
.footer-links__item {
  list-style: none;
  position: relative;
  padding-right: 2em;
  color: #666;
  font: normal 400 12px/2 "Arial", sans-serif;
}
.footer-links__item--group1:after {
  position: absolute;
  top: 0.6em;
  height: calc(100% - 1.2em);
  right: 1em;
  content: "";
  width: 0;
  border-left: solid #666 1px;
}
.footer-links__item--group1 {
}
.link {
  color: #bfbfbf;
  text-decoration: none;
}

.footer-social {
  width: 400px;
}
.footer-social__qr-container {
  position: relative;
  transition: height 0.5s;
}
.footer-social__container {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -5vw;
}

.flex-end {
  justify-content: flex-end;
}
.footer-social__item {
  flex: 0 0 33%;
  padding: 8px 0;
  position: relative;
  display: -ms-flexbox;
  display: flex;
  color: #666;
}
.footer-social__social-link {
  display: inline-block;
  height: 20px;
  width: 20px;
  vertical-align: middle;
  overflow: hidden;
  margin-right: 10px;
}
.footer-social__item a {
  color: #bfbfbf;
  cursor: pointer;
}

.footer-social__social-links-image {
  height: 100%;
  vertical-align: bottom;
}

.floating-button__group {
  position: fixed;
  bottom: 160px;
  right: -190px;
  z-index: 1001;
}

.floating-button__content {
  margin-bottom: 1px;
  transition: transform 0.5s ease-in-out;
}
.floating-button__link {
  display: flex;
  align-items: center;
  width: 240px;
  height: 50px;
  line-height: 50px;
  background-color: #1f1f1f;
}

.floating-button__img {
  width: 51px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.floating-button__img img {
  width: 24px;
  height: auto;
}
.floating-button__title {
  font-family: "PingFang SC", "Hiragino Sans GB", "Noto Sans CJK SC",
    "Source Han Sans SC", "Microsoft YaHei", "SimHei", Helvetica, Arial;
  font-size: 14px;
  line-height: normal;
  color: #fff;
}

@media screen and (min-width: 1200px) {
  .floating-button__content-action {
    transform: translateX(-190px);
  }
}

@media screen and (max-width: 1200px) {
  .footer {
    margin-bottom: 60px;
  }
  .footer-social {
    max-width: 100%;
    width: 100%;
  }
  .footer-social-and-links {
    margin-bottom: 60px;
  }
  .footer-social-and-links {
    display: flex;
    flex-direction: column-reverse;
    margin-bottom: 0;
    padding: 14px 40px 24px;
    bottom: 0;
  }

  .floating-button__group {
    bottom: 0;
    right: 0;
    left: 0;
    display: flex;
    background: #000;
  }

  .floating-button__content {
    transition: none;
    flex: 1;
    margin-bottom: 0;
    margin-right: 2px;
    padding-top: 2px;
    height: 60px;
    box-sizing: border-box;
  }
  .floating-button__content:first-child {
    margin-left: 2px;
  }
  .floating-button__content:first-child .floating-button__link {
    border-top-left-radius: 4px;
  }
  .floating-button__content:first-child .floating-button__link {
    border-top-left-radius: 2.6px;
  }
  .floating-button__link {
    height: 100%;
    line-height: 58px;
    border-radius: 0;
    width: 100%;
    flex-direction: column;
    justify-content: center;
  }
  .floating-button__img {
    width: 24px;
    margin-bottom: 2px;
  }
  .floating-button__img img {
    width: 24px;
  }
  .floating-button__title {
    font-size: 11px;
    font-weight: normal;
    letter-spacing: normal;
  }
}
</style>
